// extracted by mini-css-extract-plugin
module.exports = {"header":"WorkspacesBox_header__xo0oG","box":"WorkspacesBox_box__T02Iw","node":"WorkspacesBox_node__2NE6A"};